<template>
    <q-dialog
        v-model="showModal"
        :maximized="$q.screen.lt.md"
        persistent
    >
        <q-card :style="$q.screen.gt.sm ? 'width: 700px; max-width: 80vw;' : ''">
            <q-card-section class="row items-center q-pb-none">
                <slot name="header">
                    <div class="text-h6">{{ $t('transfers.send_money_steps.send_payment_receipts') }}</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </slot>
            </q-card-section>

            <q-card-section class="q-pt-md">
                <div>
                    <q-banner rounded class="bg-green-2 text-black q-mb-md" v-if="existReceipts">
                        <q-icon name="fa fa-circle-check" color="green-8" size="sm"/>&nbsp;
                        <span v-if="existReceipts > 1">{{ $t('transfers.send_money_steps.files_already_uploaded', {number_of_files: existReceipts}) }} </span>
                        <span v-else>{{ $t('transfers.send_money_steps.file_already_uploaded', {number_of_files: existReceipts}) }} </span>
                        {{ $t('transfers.send_money_steps.we_ll_update_your_order_status_shortly') }}
                    </q-banner>
                    <slot name="default">
                        <div class="q-py-md">{{ $t('transfers.send_money_steps.please_upload_payment_receipt_for_this_order') }}</div>
                    </slot>
                    <file-collector
                        v-model="transfer.receipts"
                        multiple
                        class="col-12"
                        :label="$t('transfers.send_money_steps.payment_receipts')"
                        name="receipts"
                        color="grey-8"
                        :attach-file-label="$t('attach_file')"
                        ref="collector"
                        camera
                        @count="fileCounts"
                        file-types="*"
                        :max-file-size="25 * 1024 * 1024"
                        :max-total-size="40 * 1024 * 1024"
                        :error="transfer.errors.get('receipts', true)"
                        :cameraLabel="$t('take_photo')"
                        :of="$t('of')"
                    />
                </div>
            </q-card-section>

            <q-card-actions align="right" class="text-primary">
                <q-btn flat :label="$t('back')" v-close-popup />
                <q-btn color="primary"
                       @click="submit"
                       :loading="loading"
                       :style="loading ? 'width: 200px':''"
                       :disabled="!count_of_files"
                >{{$t('send')}}
                    <template v-slot:loading>
                        <div class="col">
                            <q-spinner-radio class="on-left"/>
                            {{$t('sending')}} ...
                        </div>
                    </template>
                </q-btn>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<script>

import Transfer from "../../../../models/Transfer"
import FileCollector from "src/components/FileCollector.vue"

export default {
    name: "PaymentReceiptsDialog",
    model: {
        prop: 'open',
        event: 'change'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        transferReference: {
            type: String,
            required: true
        },
        existReceipts: {
            type: Number,
            default: 0
        },
        txid: {
            type: Number,
            default: 0
        }
    },
    computed: {
        showModal: {
            get: function () {
                return this.open
            },
            set: function (value) {
                this.$emit('change', value)
            }
        },
        receipts() {
            return this.transfer.receipts
        }
    },
    data() {
        return {
            loading: false,
            count_of_files: 0,
            existsReceipts: 0,
            transfer: new Transfer({
                reference: this.transferReference,
                transaction_id: this.txid,
                receipts: {}
            })
        }
    },
    methods: {
        submit() {
            this.loading = true
            this.transfer.sentPaymentReceipts(({message}) => {
                this.loading = false
                this.count_of_files = 0
                this.$q.notify({
                    message: message
                })
                this.showModal = false
                this.$emit('uploaded')
            }).catch(error => {
                this.loading = false
                switch (error.status) {
                    case 429:
                        this.$q.notify({
                            message: 'Too may request.',
                            caption: "Please try again another day!",
                            color: 'negative',
                            icon: 'fa fa-exclamation-triangle'
                        })
                        break;
                    case 412:
                        this.$q.notify({
                            message: error.data.error,
                            color: 'negative',
                            icon: 'fa fa-exclamation-triangle',
                            timeout: 5000,
                        })

                }
            })
        },
        fileCounts(count) {
            this.count_of_files = count
        },
    },
    created() {},
    mounted() {
    },
    watch: {
        receipts(val) {
            if (!val) {
                this.$refs.collector.reset()
            }
        }
    },
    components: {
        FileCollector
    },
}
</script>
<style>

</style>
